import mainAPI from "../api/MainAPI";
import {isCordova} from "./isCordova";
import {onLoginSuccess} from "../components/pages/login/Login";

const handleDeepLink = (url) => {
	console.log('handleDeepLink:', url);
	try {
		// Parse the URL to extract parameters
		const urlObj = new URL(url);
		const path = urlObj.pathname;
		const params = new URLSearchParams(urlObj.search);

		// Handle different deep link paths
		if (path === '/login') {
			const tempToken = params.get('temp_token');
			if (tempToken) {
				console.log('Temp token received:', tempToken);

				// Handle temp token login similar to loginHome
				const handleTempTokenLogin = async () => {
					try {
						// Check if token starts with "temp_"
						if (!tempToken.startsWith("temp_")) {
							console.log('Invalid temp token format');
							return;
						}

						// Get the raw token from the short term token
						const token = await mainAPI.short_term_token.get(tempToken);
						localStorage.token = token.raw_token;

						// Get user data
						const user = await mainAPI.user.get();

						// Expire the short term token
						await mainAPI.short_term_token.expire(tempToken);

						// Handle login success
						if(isCordova()){
							onLoginSuccess(user, false);
						}else{
							onLoginSuccess(user, true);
						}



					} catch (error) {
						console.error('Error handling temp token login:', error);
					}
				};
				handleTempTokenLogin();
			}
		}

	} catch (error) {
		console.error('Error handling deep link:', error);
	}
}


export default handleDeepLink;